import React from 'react';
import { t } from '../../../../modules/infra/i18n';
import Money from '../../../common/money';
import * as shapes from '../../shapes';

const ChargeButton = ({ totalAmount, charge, disabled }) => (
  <button
    type="button"
    className="c-btn"
    onClick={charge}
    disabled={disabled}
  >
    {t('register:sale.charge_button.charge')}
    <span className="u-ml-" display-if={totalAmount}>
      <Money>{totalAmount}</Money>
    </span>
  </button>
);
ChargeButton.propTypes = {
  charge: shapes.handler.isRequired,
  totalAmount: shapes.number,
  disabled: shapes.flag.isRequired,
};
ChargeButton.defaultProps = {
  totalAmount: 0,
};

export default ChargeButton;
